module.exports = __webpack_public_path__ + "img/placeholder.9c17fb2e.png";